<div>
  <!-- Left Sidebar -->
  <aside id="leftsidebar" class="sidebar" (mouseenter)="mouseHover($event)" (mouseleave)="mouseOut($event)">
    <!-- Menu -->
    <div class="menu">
      <ul id="sidebarnav" class="list"
        [ngStyle]="{ position: 'relative', 'max-height': listMaxHeight + 'px', 'max-width': listMaxWidth + 'px' }">
        <!-- <li class="sidebar-user-panel">
                    <div class="user-panel">
                        <div class=" image">
                            <img src="assets/images/usrbig.jpg" class="img-circle user-img-circle" alt="User Image" />
                        </div>
                    </div>
                    <div class="profile-usertitle">
                        <div class="sidebar-userpic-name"> Emily Smith </div>
                        <div class="profile-usertitle-job ">Manager </div>
                    </div>
                </li> -->
        <!-- First level menu -->
        <li [class.active]="sidebarItem.showMenu === sidebarItem.title" *ngFor="let sidebarItem of sidebarItems"
          [routerLinkActiveOptions]="{ exact: true }" routerLinkActive=" active">
          <a [routerLink]="sidebarItem.class === '' ? [sidebarItem.path] : null" [ngClass]="[sidebarItem.class]" style="cursor: pointer !important;"
            (click)="callMenuToggle($event, sidebarItem.title, sidebarItem)">
            <i [ngClass]="[sidebarItem.icon]"></i>
            <span class="hide-menu" style="padding-top:5px; white-space: normal;">
              {{ sidebarItem.title | translate }} </span>
          </a>
          <!-- Second level menu -->
          <ng-container *ngIf="!sidebarItem.menuToggleOff">
            <ul class="ml-menu" *ngIf="sidebarItem.submenu.length > 0" style="list-style-type: none">
              <li *ngFor="let sidebarSubItem of sidebarItem.submenu"
                [class.activeSub]="showSubMenu === sidebarSubItem.title"
                [routerLinkActive]="sidebarSubItem.submenu.length > 0 ? '' : 'active'" style="list-style: none">
                <a [routerLink]="sidebarSubItem.submenu.length > 0 ? null : [sidebarSubItem.path]"
                  (click)="callSubMenuToggle(sidebarSubItem.title)" [ngClass]="[sidebarSubItem.class]" style="cursor: pointer !important;">
                  <i [ngClass]="[sidebarSubItem.icon]"></i>
                  <span class="hide-menu" style="white-space: normal;">{{ sidebarSubItem.title | translate}} </span>
                </a>
                <!-- Third level menu -->
                <ul class="collapse" *ngIf="sidebarSubItem.submenu.length > 0"
                  [ngClass]="{ in: showSubMenu === sidebarSubItem.title }">
                  <li *ngFor="let sidebarSubsubItem of sidebarSubItem.submenu" [ngClass]="[sidebarSubsubItem.class]">
                    <a [routerLink]="[sidebarSubsubItem.path]">
                      {{ sidebarSubsubItem.title }}
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </ng-container>
        </li>
        <li>
          <div class="copy_right">
            <div><span>{{'c_logo' | translate}}</span></div>
            <div><span>{{'all_rights_reserved'|translate}}</span></div>
          </div>
        </li>
      </ul>
    </div>
    <!-- #Menu -->
  </aside>
  <!-- #END# Left Sidebar -->
</div>